import {inkApp} from './app.component.js';

// Ink Finder app
export const inkfinder = angular
.module('inkfinder', [
  'ui.router',
  'angular-loading-bar',
  'angulartics',
  'angulartics.google.analytics',
  'angularMoment',
  'angularUtils.directives.dirPagination',
  'bootstrapLightbox',
  'duScroll',
  'fcsa-number',
  'monospaced.elastic',
  'ngAnimate',
  'ngSanitize',
  'ngCookies',
  'ngMask',
  'ngFileUpload',
  'ngPasswordStrength',
  'satellizer',
  'ui.bootstrap',
  'ui.router.title',
  'ui.select',
  'ngMap',
  'tw.directives.clickOutside',
  'picardy.fontawesome',
  'ng.ckeditor'
])
.component('inkApp', inkApp)
.name;



// WEBPACK FOOTER //
// ./app.js